<template>
    <div class="t_content_view">
        <el-page-header @back="goBack" content="新增/编辑活码" />
        <div class="t_add_title">
            基础信息
        </div>
        <el-form label-width="120px">
            <el-form-item label="渠道活码名称：">
                <el-input style="width:190px" placeholder="请输入渠道活码名称" v-model="form.name"  clearable />
            </el-form-item>
            <!-- <el-form-item label="活码类型：">
                <el-radio-group v-model="form.qrType">
                    <el-radio :label="1" >多人</el-radio>
                </el-radio-group>
            </el-form-item> -->
            <el-form-item label="选择成员：">
          
                <!-- <el-select multiple v-model="form.member_ids" placeholder="请选择成员">
                    <el-option v-for="(item,index) in allpeolist.data" 
                    :key="index"
                    style="height: auto;line-height:normal;padding:8px 32px 8px 20px"
                     :value="item.internal_user_id" :label="item.wx_name"  >
                    </el-option>
                </el-select> -->
                <!-- <el-cascader v-model="form.member_ids" :options="allcomppeolist.data" @change="handleChange" /> -->
                 <el-cascader
                    v-model="selectedPath.data"
                    :options="allcomppeolist.data"
                    :props="{ expandTrigger: 'hover',multiple: true }"
                    placeholder="请选择成员"
                    clearable
                    @change="handleChange"
                    />
            </el-form-item>
            <el-form-item label="选择渠道：">
                <el-select style="width: 190px;" v-model="form.channel_id" placeholder="请选择渠道"
                value-key="id" >
                    <el-option v-for="(item,index) in allqdlist.data" 
                    :key="index"
                    :label="item.title" 
                    :value="item.id" />
                </el-select>
            </el-form-item>
        </el-form>
        <div style="margin-top:20px">
            <el-button color="#4F46E5" @click="addhm" type="primary">确定</el-button>
            <el-button @click="resthm">取消</el-button>
        </div>
    </div>

</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import { qdmlist,addqdhm,detailqdhm,changeqdhm,newgethmqdlist,newgethmcylist,newgethmcreate,newgethdetail,newgetcomppeo,newgethmcreatev2 } from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
const goBack = () => {
    router.push({ path: '/navtkyl/ewmlist' })
}
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    console.log(route.query.id)
    changeid.value=route.query.id
    //如果有值，说明是编辑，查询数据详情
    if(route.query.id!=''&&route.query.id!=undefined){
        changeinfo()
    }
    //获取所有成员下拉
    getallpeolist()
    //获取主体+成员
    getcomppeolist()
    //获取所有渠道下拉
    getallqdlist()
    
})
//当前是否有修改id，来判断当前是否是编辑
const changeid = ref('')
//如果是编辑，获取当前数据
const changeinfo = ()=>{
    form.member_ids = []
    selectedPath.data = []
    newgethdetail({id:route.query.id}).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log(response.data.data)
            form.name=response.data.data.name
            // form.qrType=response.data.result.qrType
            form.channel_id=response.data.data.channel_id
            // form.way.id=response.data.result.wayId
            // form.way.title=response.data.result.wayName

            for(var x=0;x<response.data.data.members.length;x++){
                form.member_ids.push(response.data.data.members[x].internal_user_id)
            }

            //将一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]转为二维数组[[1,2],[3,4]]格式
            selectedPath.data = response.data.data.corp_members?.map(item => [item.corp_id, item.id]) || []
            console.log('selectedPath.data')
            console.log(response.data.data.corp_members)
            console.log(selectedPath.data)

        }
    })
}

//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgethmcylist({page:1,page_size:20000,is_wecom_disabled:0}).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log('成员')
            console.log(response.data)
            allpeolist.data = response.data.data.data
        }
    })
}
//获取主体+成员下拉
const allcomppeolist = reactive({
    data:[]
})
//获取主体+成员下拉
const getcomppeolist = ()=>{
    newgetcomppeo().then((response)=>{
        if (response.data.msg.code == 0) {
            
            allcomppeolist.data = response.data.data.map(corp => {
                const hasDevices = corp.device && corp.device.length > 0;
                return {
                value: corp.corp_id,
                label: corp.corp_name,
                // 无设备时禁用该项并清空 children
                disabled: !hasDevices,
                children: hasDevices
                    ? corp.device.map(device => ({
                        value: device.id,
                        label: device.name,
                        // 可添加其他自定义属性，如在线状态图标等
                        // 此处保留原始设备对象以便扩展
                        rawDevice: device
                    }))
                    : []
                };
            });
           console.log('主体+成员')
            console.log(allcomppeolist.data)
        }
    })
}

//主体+成员下拉选中的数据
const selectedPath = reactive({
    data:[]
})
//联动数据，过滤数据，只能选一个一级多个二级
const handleChange = (val)=>{
    console.log(val)
    //只能选一个主体
    if(val && val.length > 0){
        // 获取所有一级节点值（父节点ID）
        const parentIds = val.map(item => item[0])
        // 去重获取所有唯一的父节点
        const uniqueParentIds = [...new Set(parentIds)]
        
        // 如果存在多个父节点，只保留最后一个选中的父节点及其子节点
        if(uniqueParentIds.length > 1){
            const lastParentId = uniqueParentIds[uniqueParentIds.length - 1]
            // 筛选出最后一个父节点的所有相关节点
            const newVal = val.filter(item => item[0] === lastParentId)
            // 延迟更新确保界面正确响应
            setTimeout(()=>{
                selectedPath.data = newVal
                console.log(selectedPath.data)
            }, 0)
        }
    }
    
}
//所有渠道下拉
const allqdlist = reactive({
    data:[]
})
//获取所有渠道下拉
const getallqdlist = ()=>{
    newgethmqdlist({ page:1,
    page_size:200000,
    channel_title:'',
    channel_type_id:''}).then((response)=>{
        if (response.data.msg.code == 0) {
            // console.log(response.data.result)
            allqdlist.data = response.data.data.data
        }
    })
}

//表单内容
const form = reactive({
    name: '',
    qrType: 1,
    member_ids: [],
    channel_id:'',
    corp_id:[]
    // way:{
    //     id:'',
    //     title:''
    // }
})
//企业logo
const imageUrl = ref('')
//logo上传成功
const handleAvatarSuccess = (response)=>{
    console.log('----')
    console.log(response)
    
}
//确定提交
const addhm = ()=>{
    console.log(form)
    
    var corp_members = []
    //讲二维数组[[1,2],[3,4]]转为一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]格式
    corp_members = selectedPath.data.map(item => ({
        corp_id: item[0],
        id: item[1]
    }))
       
       
    
    //判断是新增还是编辑
        if(route.query.id!=''&&route.query.id!=undefined){
            newgethmcreatev2({
                id:route.query.id,
                name:form.name,
                // qrType:form.qrType,
                member_ids:form.member_ids.join(","),
                channel_id:form.channel_id,
                status:1,
                corp_members:corp_members,
                class:1
                // wayId:form.way.id,
                // wayName:form.way.title
            }).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '修改成功！',
                    })
                    router.push({ path: '/navtkyl/ewmlist' })
                }
            })
        }else{
            newgethmcreatev2({
                name:form.name,
                // qrType:form.qrType,
                member_ids:form.member_ids.join(","),
                channel_id:form.channel_id,
                status:1,
                corp_members:corp_members,
                class:1
                // wayId:form.way.id,
                // wayName:form.way.title
            }).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '添加成功！',
                    })
                    router.push({ path: '/navtkyl/ewmlist' })
                }
            })
        }
}
//取消
const resthm = ()=>{
    router.push({ path: '/navtkyl/ewmlist' })
}
</script>
<style scoped>

/* .t_content_view {
    padding: 20px;
} */



.t_scexample {
    width: 200px;
    margin-left: 30px
}

.t_scstyle_box {
    display: flex;
    background-color: #F1F3F9;
    padding: 20px;
}
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

:deep(ww-open-data iframe){
    width: 100px !important;
    height: 20px !important;
}

</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 29px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>